import { render, staticRenderFns } from "./SlsD_Total.vue?vue&type=template&id=e2d4a930"
import script from "./SlsD_Total.vue?vue&type=script&lang=js"
export * from "./SlsD_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports